export default __webpack_public_path__ + "static/media/lunch.d9cfaa83.svg";